import React, { useEffect, useRef } from "react";
import "../../sass/landing/routine.scss";

const SITUATIONS = [
  "Agenda de um lado, prontuário em outro e cobrança no WhatsApp.",
  "Confirmar a sessão de amanhã por mensagem, paciente por paciente.",
  "Lembrar quem ainda não pagou, e adiar a conversa porque ela é desconfortável.",
  "Reler anotações antes da sessão para lembrar onde vocês pararam.",
  "Fechar o mês conferindo conversa por conversa o que entrou.",
];

const RoutineSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section || typeof IntersectionObserver === "undefined") return undefined;

    // O conteúdo permanece visível por padrão: sem JavaScript ou com movimento
    // reduzido, a seção continua totalmente acessível.
    const prefersReducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReducedMotion) return undefined;

    const elements = section.querySelectorAll("[data-routine-reveal]");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -5% 0px" }
    );

    elements.forEach((element) => {
      // Se um elemento já estiver na área visível ao montar, não o escondemos.
      const bounds = element.getBoundingClientRect();
      const onScreen = bounds.top < window.innerHeight * 0.94 && bounds.bottom > 0;
      if (onScreen) {
        element.classList.add("is-revealed");
      } else {
        element.classList.add("is-pending");
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="lp-routine"
      aria-labelledby="routine-title"
    >
      <div className="lp-shell lp-routine__grid">
        <header className="lp-routine__header" data-routine-reveal>
          <h2 id="routine-title">O atendimento já exige sua atenção.</h2>
          <p className="lp-routine__statement">
            A parte administrativa não precisa ocupar o resto do seu dia.
          </p>
        </header>

        <div className="lp-routine__body">
          <p className="lp-routine__intro" data-routine-reveal>
            Quem atende por conta própria conhece bem esta parte do trabalho:
          </p>

          <ul className="lp-routine__list">
            {SITUATIONS.map((text, index) => (
              <li
                key={text}
                data-routine-reveal
                style={{ "--routine-index": index }}
              >
                {text}
              </li>
            ))}
          </ul>

          <p className="lp-routine__close" data-routine-reveal>
            Nada disso é atendimento. Mas tudo isso costuma ficar na sua cabeça.
            <strong>
              O PsyAssist foi feito para carregar essa parte junto com você.
            </strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default RoutineSection;
